import { CircularProgress, Grid, Modal } from '@mui/material'
import styles from './Loader.module.css'

const Loader = ({ loading }: { loading: boolean }) => (

    <Modal open={loading}>
        <Grid className={styles.loader_container}>
            <CircularProgress className={styles.loader} />
        </Grid>
    </Modal>
  )

  export default Loader;